type TDefineNativeTokenSymbol = ({ chainId }: { chainId: number | null }) => string
const defineNativeTokenSymbol: TDefineNativeTokenSymbol = ({ chainId }) => {
  switch(chainId) {
    case 43114:
      return 'AVAX'
    case 100:
      return 'xDAI'
    case 666666666:
      return 'DEGEN'
    case 137:
    default:
      return 'ETH'
  }
}

export default defineNativeTokenSymbol